<template>
  <div>
    <pre>"{{ this.projectDetail2 }}":[</pre>
    <div v-for="(project, index) in projects" :key="index">
      <pre>{{ project.url }}</pre>
    </div>
    <pre>],</pre>
  </div>
</template>

<script>
export default {
  name: 'myCldRaw',
  props: {
    projectPath: {
      type: String,
      required: true,
    },
    projectDetail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      projects: [], // Array to store project data
    };
  },
  created() {
    this.fetchProjects();
  },
  computed: {
    projectDetail2() {
      return this.projectDetail.replace(/\//g, '_');
    }
  },
  methods: {
    async fetchProjects() {
      try {
        // First fetch to get the URL of the text file
        const response = await fetch(`http://localhost:3001/api/raw?folder=${this.projectPath}/${this.projectDetail}`);
        const jsonResponse = await response.json(); // Assuming the endpoint returns a JSON array with the URL

        // Extract the URL from the JSON array
        const textFileUrl = jsonResponse[0];

        // Second fetch to read the contents of the text file
        console.log("==========-------->" + textFileUrl);
        const textFileResponse = await fetch("https://res.cloudinary.com/alvin-tan/raw/upload/" + textFileUrl.trim());
        const textData = await textFileResponse.text(); // Fetch the text file content
console.log("-------->" + textData);
        const lines = textData.split('\n'); // Split the text content into lines

        // Transform the array of strings into an array of objects
        this.projects = lines.filter(line => line.trim() !== '').map((url) => {
          return {
            url: '"' + url.trim() + '"',
          }
        });
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    },
  },
};
</script>

<style scoped>
/* Add your component styles here */
ul {
  list-style-type: none;
  padding: 0;
}

li {
  border: 1px solid #ddd;
  margin: 10px 0;
  padding: 10px;
}

img {
  max-width: 100%;
  height: auto;
}
</style>
